import { Product, ProductCategory } from '../types/Product';

export const productCategories: ProductCategory[] = [
  {
    id: 'oils',
    name: 'Bučna olja',
    description: 'Naša tradicionalna in premium bučna olja, pridelana po receptih naših prednikov.',
    image: '/images/categories/oils.jpg'
  },
  {
    id: 'spreads',
    name: 'Namazi',
    description: 'Okusni in zdravi namazi iz bučnih semen in drugih lokalnih sestavin.',
    image: '/images/categories/spreads.jpg'
  },
  {
    id: 'seeds',
    name: 'Bučna semena',
    description: 'Pražena bučna semena in drugi izdelki iz semen.'
  },
  {
    id: 'specialties',
    name: 'Posebnosti',
    description: 'Unikatni izdelki iz buč in bučnega olja, od sladkih do slanih dobrot.',
    image: '/images/categories/specialties.jpg'
  }
];

export const products: Product[] = [
  {
    id: 'traditional-oil',
    name: 'Tradicionalno bučno olje',
    description: 'Naše tradicionalno 100% hladno stiskano bučno olje, pridelano po receptu naših prednikov.',
    image: '/images/products/traditional-oil.jpg',
    price: '12,90 €',
    categoryId: 'oils',
    featured: true,
    details: [
      '100% hladno stiskano',
      'Brez aditivov in konzervansov',
      'Pridelano iz lokalnih buč',
      'Steklena embalaža'
    ],
    ingredients: ['100% bučna semena']
  },
  {
    id: 'premium-oil',
    name: 'Premium bučno olje',
    description: 'Naše najboljše bučno olje, pridelano iz izbranih bučnih semen s kontrolirano fermentacijo.',
    image: '/images/products/premium-oil.jpg',
    price: '15,90 €',
    categoryId: 'oils',
    featured: true,
    details: [
      'Limited Edition',
      'Posebej izbrana semena',
      'Kontrolirana fermentacija',
      'Intenzivnejši okus'
    ]
  },
  {
    id: 'organic-oil',
    name: 'Ekološko bučno olje',
    description: 'Ekološko pridelano bučno olje iz certificiranih ekoloških kmetij.',
    image: '/images/products/organic-oil.jpg',
    price: '16,90 €',
    categoryId: 'oils',
    details: [
      'Ekološka pridelava',
      'Certificirano',
      'Bogato z vitamini in minerali'
    ]
  },
  {
    id: 'pumpkin-spread',
    name: 'Bučni namaz',
    description: 'Kremast namaz iz bučnih semen in našega bučnega olja.',
    image: '/images/products/pumpkin-spread.jpg',
    price: '6,90 €',
    categoryId: 'spreads',
    details: [
      'Odličen za zajtrk',
      'Brez dodanega sladkorja',
      'Naravni viri beljakovin'
    ]
  },
  {
    id: 'roasted-seeds',
    name: 'Pražena bučna semena',
    description: 'Tradicionalno pražena bučna semena s soljo.',
    image: '/images/products/roasted-seeds.jpg',
    price: '4,50 €',
    categoryId: 'seeds',
    details: [
      'Ročno pražena',
      'Rahlo soljena',
      'Odličen prigrizek'
    ]
  },
  {
    id: 'pumpkin-chocolate',
    name: 'Čokolada z bučnimi semeni',
    description: 'Temna čokolada z dodatkom praženih bučnih semen.',
    image: '/images/products/pumpkin-chocolate.jpg',
    price: '5,90 €',
    categoryId: 'specialties',
    new: true,
    details: [
      '70% temna čokolada',
      'Hrustljava bučna semena',
      'Ročno izdelana'
    ]
  },
  {
    id: 'pumpkin-pesto',
    name: 'Bučni pesto',
    description: 'Unikatni pesto iz bučnih semen, bučnega olja in lokalnih zelišč.',
    image: '/images/products/pumpkin-pesto.jpg',
    price: '7,50 €',
    categoryId: 'specialties',
    details: [
      'Odlično za testenine',
      'Z domačimi zelišči',
      'Brez konzervansov'
    ]
  },
  {
    id: 'gift-set',
    name: 'Darilni set',
    description: 'Elegantni darilni set z izbiro naših najboljših izdelkov.',
    image: '/images/products/gift-set.jpg',
    price: '25,90 €',
    categoryId: 'specialties',
    featured: true,
    details: [
      'Tradicionalno bučno olje 250ml',
      'Pražena bučna semena 100g',
      'Bučni namaz 150g',
      'Elegantna embalaža'
    ]
  }
];

export const getFeaturedProducts = (): Product[] => {
  return products.filter(product => product.featured);
};

export const getNewProducts = (): Product[] => {
  return products.filter(product => product.new);
};

export const getProductsByCategory = (categoryId: string): Product[] => {
  return products.filter(product => product.categoryId === categoryId);
};

export const getProductById = (id: string): Product | undefined => {
  return products.find(product => product.id === id);
};